import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationComponent } from './navigation.component';
import { SdsSelectionPanelModule, SdsSideToolbarModule } from '@gsa-sam/components';
import { SdsFiltersModule } from '@gsa-sam/sam-formly';

@NgModule({
  declarations: [NavigationComponent],
  exports: [NavigationComponent],
  imports: [CommonModule, SdsSelectionPanelModule, SdsSideToolbarModule, SdsFiltersModule],
})
export class NavigationModule {}
